import {PropsWithChildren} from 'react';

interface LinkProps extends PropsWithChildren {
  href: string;
}

export const Link = ({ href, children }: LinkProps) => (
  <a href={href} target="_blank" rel="noreferrer noopener">{children}</a>
)
